import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { useToast } from "@/components/ui/use-toast";

const Home = () => {
  const navigate = useNavigate();
  const { user, signInWithGoogle } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    // If user is already logged in, redirect to test-mode
    if (user) {
      navigate('/test-mode');
    }
  }, [user, navigate]);

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      toast({
        title: "Welcome!",
        description: user?.displayName 
          ? `Signed in as ${user.displayName}`
          : "Successfully signed in with Google",
      });
    } catch (error) {
      console.error('Error signing in:', error);
      toast({
        variant: "destructive",
        title: "Error signing in",
        description: "Please try again",
      });
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="text-center">
        <div className="mb-6">
          <img 
            src="/jambace-logo.svg" 
            alt="JAMBACE Logo" 
            className="h-[60px] sm:h-[100px] w-auto mx-auto"
          />
        </div>
        <h1 className="text-[40px] sm:text-[64px] font-bold mb-4 leading-[1.1]">
          Welcome To UTME<br />
          Past Questions
        </h1>
        
        <p className="text-[14px] sm:text-[16px] text-purple-600 bg-purple-100 inline-block px-4 py-2 rounded-lg mb-8">
          Sign in with Google to start quiz
        </p>

        <div 
          onClick={handleGoogleSignIn}
          className="flex items-center justify-center gap-2 border border-gray-300 rounded-full px-6 py-3 cursor-pointer hover:bg-gray-50 w-[240px] mx-auto"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span>Continue with Google</span>
        </div>
      </div>
    </div>
  );
};

export default Home; 